import classNames from "classnames";
import React from "react";

const debug = require("debug")("app:Navbar");

interface NavbarProps {
  children?: React.ReactNode;
  left?: React.ReactNode;
  center?: React.ReactNode;
  bottom?: React.ReactNode;
  className?: string;
}

export default function Navbar(props: NavbarProps) {
  return (
    <nav
      className={classNames({
        "flex items-center justify-center flex-none w-full transition duration-100 ease-in-out":
          true,
        "z-10 sticky top-0 left-0 text-white bg-newPrim h-16 border-b border-transparent ease-in-out px-2":
          true,
        [props.className || ""]: props.className,
      })}
      style={{
        backdropFilter: "blur(7px)",
        WebkitBackdropFilter: "blur(7px)",
      }}
    >
      <div className="flex flex-col w-full gap-1 container md:px-10 lg:px-20 xl:px-28">
        <div className={`flex items-center justify-between w-full`}>
          <div className="flex-1">{props.left}</div>
          {props.center}
          <div className="text-right flex-1">{props.children}</div>
        </div>
        {props.bottom}
      </div>
    </nav>
  );
}
